import { Component } from '@angular/core';
import { map } from "rxjs/operators";
import { IUserMembership, IUser, Page, SupportService } from 'src/app/xena-api';



@Component({
    selector: 'app-support-user-membership-list',
    templateUrl: './support-user-membership-list.html',
    standalone: false
})
export class SupportUserMembershipListComponent {
  userMemberships: IUserMembership[] = [];

  constructor(
    private suportInformationService: SupportService) {
  }

  usersDatasource = (queryString: string): Promise<IUser[]> => {
    return this.suportInformationService.listUsers({ queryString, forceNoPaging: false }).pipe(map((x: Page<IUser>) => x.entities)).toPromise()
  }

  async onUserChange(e: CustomEvent) {
    const data: IUser = e.detail;
    if (data !== null) {
      this.userMemberships = await this.suportInformationService.listUserMemberships(data.id, { forceNoPaging: true }).pipe(map(data => data.entities)).toPromise()
    } else {
      this.userMemberships = [];
    }
  }
}
